
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function SexualWellnessPage() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  const treatments = [
    {
      name: 'Proprietary Lubrication Enhancement',
      description: 'A specially formulated blend of medications to increase natural lubrication in women, restoring comfort and pleasure.',
      benefits: ['Enhanced comfort', 'Restored pleasure', 'Natural lubrication', 'Improved intimacy']
    },
    {
      name: 'PT-141 (Bremelanotide)',
      description: 'Known for enhancing libido in both men and women, this treatment is perfect for those experiencing a dip in sexual desire.',
      benefits: ['Enhanced libido', 'Increased desire', 'Works for both genders', 'Natural enhancement']
    },
    {
      name: 'Kisspeptin',
      description: 'A breakthrough treatment to regulate hormone levels, boosting sexual health for both men and women. Also increases fertility in women.',
      benefits: ['Hormone regulation', 'Sexual health boost', 'Fertility enhancement', 'Natural approach']
    },
    {
      name: 'Sildenafil & Tadalafil',
      description: 'Trusted treatments for erectile dysfunction that support healthy circulation and enhance performance.',
      benefits: ['Improved circulation', 'Enhanced performance', 'Proven effectiveness', 'Long-lasting results']
    },
    {
      name: 'Trimix (Alprostadil, Atropine, Papaverine)',
      description: 'A highly effective solution for erectile dysfunction, combining three powerful ingredients for fast results. Works for patients where Cialis failed them.',
      benefits: ['Fast-acting results', 'Triple-action formula', 'Alternative solution', 'High effectiveness']
    },
    {
      name: 'Oxytocin for Libido',
      description: 'A natural, safe way to enhance desire and emotional connection.',
      benefits: ['Enhanced desire', 'Emotional connection', 'Natural hormone', 'Safe treatment']
    }
  ];

  const additionalServices = [
    {
      icon: 'ri-test-tube-line',
      title: 'STI Testing and Treatment',
      description: 'Comprehensive, confidential testing for sexually transmitted infections, ensuring your health and safety. With STI prevention medications such as PrEP, which is covered by insurance.'
    },
    {
      icon: 'ri-capsule-line',
      title: 'Birth Control Prescriptions',
      description: 'A wide range of birth control options tailored to your specific needs and lifestyle.'
    },
    {
      icon: 'ri-heart-add-line',
      title: 'Non-Conventional Fertility Treatments',
      description: 'Including Kisspeptin, AMH peptide, and other high-efficacy solutions designed to boost fertility success.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Sexual Health Assessments',
      description: 'Personalized consultations to assess your unique situation, offering customized treatment options and addressing underlying issues like diabetes or circulation.'
    }
  ];

  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Personalized Care',
      description: 'Every treatment is tailored to your unique needs and health profile'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Confidential Service',
      description: 'Complete privacy and discretion in all consultations and treatments'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Cutting-Edge Treatments',
      description: 'Access to the latest innovations in sexual wellness and fertility'
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'Medical Expertise',
      description: 'Expert team specializing in holistic sexual health solutions'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#8A4F8A] to-[#C8A2C8] text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/62454b0ee5a56fd9ded2637c34d6f94c.jpg)'
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Sexual Health with <span className="text-[#F0F0F0]">Personalized, Cutting-Edge Treatments</span>
            </h1>
            <p className="text-xl mb-8 text-[#F0F0F0]">
              At Prudent Medical Services, we specialize in holistic and personalized sexual health services that empower you to live your best life. We focus on addressing the root causes of your concerns, not just the symptoms.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
                <i className="ri-calendar-line mr-2"></i>
                Schedule Consultation
              </Button>
              <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
                <i className="ri-phone-line mr-2"></i>
                Call 202-269-6600
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Why Choose Our <span className="text-[#8A4F8A]">Sexual Wellness Services</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Comprehensive, confidential, and cutting-edge treatments for optimal sexual health
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-black mb-3">{benefit.title}</h3>
                <p className="text-[#B0B0B0]">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Treatments Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Core <span className="text-[#8A4F8A]">Treatment Options</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Advanced therapies for libido, performance, and fertility enhancement
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {treatments.map((treatment, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="text-xl font-bold text-black mb-3">{treatment.name}</h3>
                <p className="text-[#B0B0B0] mb-4 text-sm">{treatment.description}</p>
                
                <ul className="space-y-2">
                  {treatment.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-center text-black text-sm">
                      <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Additional <span className="text-[#8A4F8A]">Services</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Comprehensive sexual health support and preventive care
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {additionalServices.map((service, index) => (
              <div key={index} className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl shadow-lg p-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${service.icon} text-xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-3">{service.title}</h3>
                    <p className="text-[#B0B0B0]">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-black mb-4">
            Transparent <span className="text-[#8A4F8A]">Pricing</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] mb-8">
            Upfront pricing with no hidden fees
          </p>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center justify-center mb-6">
              <i className="ri-price-tag-3-line text-4xl text-[#8A4F8A] mr-4"></i>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-black">Starting at $25/month</h3>
                <p className="text-[#B0B0B0]">Affordable, accessible sexual wellness care</p>
              </div>
            </div>
            
            <ul className="text-left space-y-3 mb-8">
              <li className="flex items-center text-black">
                <i className="ri-check-line text-[#8A4F8A] mr-3"></i>
                No hidden fees or surprise charges
              </li>
              <li className="flex items-center text-black">
                <i className="ri-check-line text-[#8A4F8A] mr-3"></i>
                Personalized treatment plans
              </li>
              <li className="flex items-center text-black">
                <i className="ri-check-line text-[#8A4F8A] mr-3"></i>
                Same-day appointments available
              </li>
              <li className="flex items-center text-black">
                <i className="ri-check-line text-[#8A4F8A] mr-3"></i>
                Insurance coverage for PrEP and select treatments
              </li>
            </ul>

            <Button size="lg" className="w-full" onClick={handleConsultationClick}>
              <i className="ri-calculator-line mr-2"></i>
              Get Your Custom Quote
            </Button>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Your <span className="text-[#8A4F8A]">Treatment Journey</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Confidential Consultation', description: 'Private assessment of your sexual health concerns and goals' },
              { step: '2', title: 'Personalized Plan', description: 'Custom treatment protocol designed for your specific needs' },
              { step: '3', title: 'Treatment Initiation', description: 'Begin your personalized therapy with medical supervision' },
              { step: '4', title: 'Ongoing Support', description: 'Regular follow-ups and treatment adjustments as needed' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">{item.step}</span>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">{item.title}</h3>
                <p className="text-[#B0B0B0] text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#8A4F8A] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Enhance Your Sexual Wellness?</h2>
          <p className="text-xl mb-8 text-[#F0F0F0]">
            Take the first step towards better sexual health and intimacy
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
              <i className="ri-calendar-line mr-2"></i>
              Schedule Consultation
            </Button>
            <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
              <i className="ri-phone-line mr-2"></i>
              Call 202-269-6600
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
